import o from "classnames";
import f from "react";
import { BaseLink as u } from "./base-link.esm.js";
const c = ({
  children: a = null,
  dataTestId: e = null,
  disabled: s,
  icon: l,
  iconRight: n = !1,
  size: r = "large",
  underline: t = !0,
  white: m = !1,
  className: p,
  ...i
}) => /* @__PURE__ */ f.createElement(
  u,
  {
    as: "span",
    className: o("fuse-span-link", p),
    dataTestId: e,
    disabled: s,
    icon: l,
    iconRight: n,
    size: r,
    underline: t,
    white: m,
    ...i
  },
  a
);
c.displayName = "SpanLink";
export {
  c as SpanLink
};
